import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { LoginView, Role } from '@data/sdk/match';

interface User extends LoginView {
  currentRole: Role;
  intercomHash?: string;
  roles: Role[];
}

interface UserState {
  setUser: (user: User | undefined) => void;
  user: User | undefined;
}

export const useAppUserStore = create<UserState>()(
  persist(
    (set) => ({
      user: undefined,
      setUser: (user: User | undefined) => set(() => ({ user })),
    }),
    {
      name: 'user-profile',
    },
  ),
);
